module.exports = __webpack_public_path__ + "static/media/house-alarm.6865d5b3.mp3";